import { FeatureFlags } from "components/providers/featureFlags/flags";
import { createContext } from "react";

export type EnabledFeatureFlags = {
    [K in keyof FeatureFlags]?: FeatureFlags[K]["type"] extends "boolean"
        ? boolean
        : FeatureFlags[K]["type"] extends "enum"
          ? FeatureFlags[K]["options"][number] | undefined
          : never;
};

export type EnabledFeatureFlagsWidened = Record<
    string,
    boolean | string | undefined
>;

type FeatureFlagsContextType = [
    EnabledFeatureFlags,
    React.Dispatch<React.SetStateAction<EnabledFeatureFlags>>,
];

export const FeatureFlagsContext = createContext<FeatureFlagsContextType>([
    {},
    () => {},
]);
